<template>
    <div class="news-detail">
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>您的位置</a-breadcrumb-item>
            <a-breadcrumb-item><a href="/AssociationNews/list">學會資訊</a></a-breadcrumb-item>
            <a-breadcrumb-item><span v-text="title || '詳情'"></span></a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
            <div class="detail-wrapper" v-if="detail">
                <h1 v-text="detail.title"></h1>
                <div class="row">
                    <div class="create-time" v-text="`發布時間：${detail.createdtime}`"></div>
                    <div class="font-setting">
                        字號：
                        <a class="font-item" @click="changeFontSize('24px')" href="javascript:;">大</a>
                        <a class="font-item" @click="changeFontSize('16px')" href="javascript:;">中</a>
                        <a class="font-item" @click="changeFontSize('12px')" href="javascript:;">小</a>
                    </div>
                </div>
                <p class="intro" :style="{'font-size': fontSize}">
                    <span class="hint">导读：</span>
                    <span v-text="detail.introduce"></span>
                </p>
                <div v-html="detail.content" :style="{'font-size': fontSize}"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        callback: Function,
    },
    data(){
      return {
          title: '',
          detail: null,
          fontSize: '16px',
      }
    },
    mounted: function(){
        var rs = JSON.parse(sessionStorage.getItem('detail'))
        this.detail = rs.news
        this.title = this.detail && this.detail.title
        this.callback && this.callback(rs.relate_news.list)
    },
    methods: {
      changeFontSize: function(size){

      }
    },
    watch: {
        '$route.params.id': function(id) {
            var rs = JSON.parse(sessionStorage.getItem('detail'))
            this.detail = rs.news
            this.title = this.detail && this.detail.title
            this.callback && this.callback(rs.relate_news.list)
        }
    }
}
</script>

<style scoped>
    .news-detail {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
    }

    .news-detail {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-right: 20px;
    }

    .news-detail > .breadcrumb {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        background-color: #fff;
    }

    .news-detail > .detail {
        margin-top: 12px;
        padding: 12px 20px;
        background-color: #fff;
        flex: 1;
        position: relative;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .news-detail > .detail .row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        font-size: 16px;
        font-weight: 400;
        color: #999;
        margin-top: 20px;
    }

    .news-detail > .detail .font-setting {
        margin-left: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #999;
    }

    .news-detail > .detail .font-setting .font-item {
        margin-left: 8px;
    }

    .news-detail > .detail h1 {
        font-size: 32px;
        line-height: 41px;
        font-weight: bold;
        color: #1f1f1f;
        text-align: center;
    }

    .news-detail > .detail img {
        width: 96%;
        object-fit: contain;
    }

    .news-detail > .detail .title {
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        line-height: 21px;
        margin-top: 12px;
    }

    .news-detail > .detail .intro {
        padding: 12px;
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        background-color: #f7f7f9;
        border: 1px dashed #E1E1E8;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    
    .news-detail > .detail .intro > .hint {
        font-weight: bold;
    }

    @media only screen and (max-width: 1050px) {
        .news-detail {
            width: 100%;
        }
    }
</style>
